import { useA11y } from '@ofc/ui';

/**
 * Display preferences. Deliberately on the landing page rather than buried in a
 * menu, because the people who need them should not have to hunt.
 */
export function DisplaySettings() {
  const { settings, update } = useA11y();

  return (
    <section className="panel col">
      <h2 className="sign" style={{ margin: 0, fontSize: 16 }}>
        Display
      </h2>

      <Row
        label="Colours"
        value={settings.palette}
        options={[
          { value: 'neon', label: 'Neon' },
          { value: 'cb', label: 'Colourblind-safe' },
        ]}
        onChange={(v) => update({ palette: v as 'neon' | 'cb' })}
      />

      <Row
        label="Text size"
        value={settings.textSize}
        options={[
          { value: 'normal', label: 'Normal' },
          { value: 'large', label: 'Larger' },
        ]}
        onChange={(v) => update({ textSize: v as 'normal' | 'large' })}
      />

      <Row
        label="Motion"
        value={settings.motion}
        options={[
          { value: 'system', label: 'System' },
          { value: 'reduced', label: 'Reduced' },
        ]}
        onChange={(v) => update({ motion: v as 'system' | 'reduced' })}
      />

      <Row
        label="Vibration"
        value={settings.haptics}
        options={[
          { value: 'on', label: 'On' },
          { value: 'off', label: 'Off' },
        ]}
        onChange={(v) => update({ haptics: v as 'on' | 'off' })}
      />

      <Row
        label="Sound"
        value={settings.sound}
        options={[
          { value: 'off', label: 'Off' },
          { value: 'alerts', label: 'Your turn' },
          { value: 'all', label: 'Everything' },
        ]}
        onChange={(v) => update({ sound: v as 'off' | 'alerts' | 'all' })}
      />

      <p className="small muted" style={{ margin: 0 }}>
        Saved on this device. Motion follows your system setting unless you override it.
        Vibration buzzes on your turn, in the last seconds of a timer and at big moments.
      </p>
    </section>
  );
}

function Row({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: string;
  options: { value: string; label: string }[];
  onChange(value: string): void;
}) {
  return (
    <div className="col" style={{ gap: 4 }}>
      <span className="small muted">{label}</span>
      <div className="row" style={{ gap: 6 }}>
        {options.map((option) => (
          <button
            key={option.value}
            aria-pressed={value === option.value}
            onClick={() => onChange(option.value)}
            className="grow small"
            style={{
              minHeight: 40,
              borderColor: value === option.value ? 'var(--cyan)' : 'var(--panel-line)',
              background: value === option.value ? 'rgba(34,224,255,0.12)' : 'var(--ink-3)',
            }}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
